import React, { useState } from "react";
import { Typography, Input, Button, Checkbox, Row, Col, Form } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
// import LogoImg from "../../../assets/images/smallLogo.png";
import LogoImg from "../../../assets/images/Logo2.svg";
import BannerImg from "../../../assets/images/banner.png";
import { Link, useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { AuthAction } from "../../../redux/reducer/AuthSlice";
import toaster from "../../../components/toaster/toaster";
import { urlConstant } from "../../../constants/urlConstant";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useSelection from "antd/es/table/hooks/useSelection";

const { Title, Text } = Typography;

const SignIn = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { AuthLoading, AuthData, AuthError } = useSelector(
    (prev) => prev?.auth
  );

  const dispatch = useDispatch();

  const handleLogin = async (values) => {
    const data = {
      device_token: "a8347a0f-e857-47a2-9bf8-45366f92b429",
      device_id: "05d4013b-10ca-4ffe-aeaa-ace28b6480a3",
      device_type: 3,
      os: "Linux",
      os_version: "22.0",
      browser: "chorme",
    };
    const newValues = { ...values, ...data };
    const loginUser = await dispatch(AuthAction(newValues));
    if (loginUser?.type === "data/auth/fulfilled") {
      toast.success("User logged in successfully");
      localStorage.setItem("ACCESS_TOKEN", loginUser?.payload?.token);
      navigate(urlConstant?.dashboardConstant);
    }
  };

  return (
    <div className="signinContainer">
      <Row gutter={16} className="signinRow">
        <Col xs={24} sm={12}>
          <div className="leftSection cflex">
            <div className="leftContainer">
              <img src={LogoImg} alt="Logo" className="logo" />
              <Title level={2}>Hey, Welcome Admin! 👋</Title>
              <Text className="subtitle mb-2">
                Please sign in to your account to access the admin console.
              </Text>

              <Form
                form={form}
                layout="vertical"
                requiredMark="optional"
                onFinish={handleLogin}
                className="signin-form"
              >
                {/* Email Input */}
                <Form.Item
                  label={
                    <span>
                      Email<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="email"
                  rules={[
                    { required: true, message: "Please enter your email!" },
                    { type: "email", message: "Please enter a valid email!" },
                  ]}
                >
                  <Input
                    size="large"
                    placeholder="Email"
                    prefix={<UserOutlined />}
                  />
                </Form.Item>

                {/* Password Input */}
                <Form.Item
                  label={
                    <span>
                      Password<span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  name="password"
                  rules={[
                    { required: true, message: "Please enter your password!" },
                    {
                      min: 6,
                      message: "Password must be at least 6 characters!",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Password"
                    prefix={<LockOutlined />}
                  />
                </Form.Item>

                {/* Remember Me & Forgot Password */}
                <div className="dflex">
                  <Form.Item valuePropName="checked" noStyle>
                    <Checkbox>Remember me</Checkbox>
                  </Form.Item>
                  <Link to="/forgot-password" className="forgotPassword">
                    Forgot Password?
                  </Link>
                </div>
                {AuthError ? (
                  <p className="error-message">Invalid username or password</p>
                ) : (
                  ""
                )}
                {/* Submit Button */}
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="customButton mt-3"
                  >
                    {AuthLoading ? "Loading..." : "Login Now"}
                  </Button>
                </Form.Item>

                <Text className="subtitle mt-5 text-center">
                  © Cultivate 2025
                </Text>
              </Form>
            </div>
          </div>
        </Col>

        <Col xs={24} sm={12}>
          <div className="rightSection cflex">
            <img src={BannerImg} alt="Banner" className="banner" />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default SignIn;
